/**
 * Constants for progress container component
 * Layout and animation configuration
 */

export const PROGRESS_CONTAINER_CONSTANTS = {
  // Layout
  PADDING: {
    Y: 2, // theme.spacing units
    X: 0,
  },
  MIN_HEIGHT: 8, // theme.spacing units

  // Scrolling
  OVERFLOW: {
    X: 'auto' as const,
    Y: 'hidden' as const,
  },

  // Animations
  ENTRANCE: {
    DURATION: '0.8s',
    EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    INITIAL: {
      OPACITY: 0,
      TRANSLATE_Y: '20px',
    },
    FINAL: {
      OPACITY: 1,
      TRANSLATE_Y: '0',
    },
  },
} as const;
